import { Routes } from '@angular/router';
import { basketLoadingGuard } from '@domgen/dgx-fe-basket';
import {
  CmsPageComponent,
  cmsPageTemplateResolver,
  cmsSeoDataResolver,
} from '@domgen/dgx-fe-cms';
import { RegistrationGaCategory } from '@us-registration/util-models';

export const REGISTRATION_FEATURE_APPLIANCE_DETAILS_STEPPED_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      cmsNodePath: '/appliance-details-stepped',
      gaData: {
        category: RegistrationGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
      seoData: cmsSeoDataResolver,
    },
    canDeactivate: [basketLoadingGuard],
  },
];
